'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var KitchenHood = function (_React$Component) {
    _inherits(KitchenHood, _React$Component);

    function KitchenHood() {
        _classCallCheck(this, KitchenHood);

        return _possibleConstructorReturn(this, (KitchenHood.__proto__ || Object.getPrototypeOf(KitchenHood)).apply(this, arguments));
    }

    _createClass(KitchenHood, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M23.53 20.128h-0.206l-7.224-8.834v-8.091h-6.605v8.091l-7.224 8.834h-0.206c-1.156 0-2.064 0.908-2.064 2.064s0.908 2.064 2.064 2.064h21.466c1.156 0 2.064-0.908 2.064-2.064s-0.908-2.064-2.064-2.064zM18.865 16h-12.136l3.385-4.128h5.408l3.344 4.128zM10.32 4.029h4.954v7.018h-4.954v-7.018zM6.068 16.826h13.499l2.683 3.302h-18.906l2.724-3.302zM23.53 23.43h-21.466c-0.702 0-1.238-0.537-1.238-1.238s0.537-1.238 1.238-1.238h21.466c0.702 0 1.238 0.537 1.238 1.238s-0.537 1.238-1.238 1.238z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M22.291 21.779h1.238v0.826h-1.238v-0.826z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M19.815 21.779h1.238v0.826h-1.238v-0.826z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M17.338 21.779h1.238v0.826h-1.238v-0.826z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M12.384 25.494h0.826v3.302h-0.826v-3.302z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M18.163 25.494h0.826v3.302h-0.826v-3.302z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M6.605 25.494h0.826v3.302h-0.826v-3.302z' })
            );
        }
    }]);

    return KitchenHood;
}(_react2.default.Component);

KitchenHood.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = KitchenHood;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/kitchen-hood.js
// module id = 1109
// module chunks = 0